import React, { ChangeEvent, Dispatch, SetStateAction } from 'react';
import { HiddenInputData } from '../AddressStep';

type HiddenInputsProps = {
	setAutofillExtraInputs: Dispatch<SetStateAction<HiddenInputData>>;
	autofillExtraInputs: HiddenInputData;
};

const HiddenInputs = (props: HiddenInputsProps) => {
	const { setAutofillExtraInputs, autofillExtraInputs } = props;

	const onChange = (event: ChangeEvent<HTMLInputElement>) => {
		setAutofillExtraInputs({
			...autofillExtraInputs,
			[event.target.name]: event.target.value,
		});
	};

	return (
		<div className="absolute bottom-0">
			<input
				onChange={onChange}
				name="city"
				placeholder="City"
				type="text"
				value={autofillExtraInputs.city}
				autoComplete="address-level2"
				className="h-1 w-1 opacity-0"
				tabIndex={-1}
			/>
			<input
				onChange={onChange}
				name="state"
				placeholder="State"
				type="text"
				autoComplete="address-level1"
				value={autofillExtraInputs.state}
				className="h-1 w-1 opacity-0"
				tabIndex={-1}
			/>
			<input
				onChange={onChange}
				name="postcode"
				placeholder="Postal code"
				type="text"
				autoComplete="postal-code"
				value={autofillExtraInputs.postcode}
				className="h-1 w-1 opacity-0"
				tabIndex={-1}
			/>
		</div>
	);
};

export default HiddenInputs;
